const initVideo = () => {
  const videos = document.querySelectorAll('.jc-video');
  const buttonsPlay = document.querySelectorAll('.jc-video-play');
  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.5
  };

  let observer = new IntersectionObserver(handleIntersection, options);

  if( !videos ) return;

  buttonsPlay.forEach((button) => {
    button.addEventListener('click', () => {
      const curVideo = document.getElementById(button.dataset.id);

      if (!button.classList.contains('is-play')) {
        for (let i = 0; i < videos.length; i++) {
          if (videos[i] !== curVideo && !videos[i].paused) {
            videos[i].pause();
          }
        }

        buttonsPlay.forEach((btn) => {
          btn.classList.remove('is-play');
        });

        button.classList.add('is-play');
        curVideo.play();
      } else {
        button.classList.remove('is-play');
        curVideo.pause();
      }
    });
  });

  function handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.target.classList.contains("autoplay")) {
        if (entry.isIntersecting) {
          entry.target.play();
        } else {
          entry.target.pause();
        }
      }
    });
  }

  videos.forEach(video => {
    observer.observe(video);
  });
};

initVideo();